export default __webpack_public_path__ + "static/stone-cae2affa22e79774c04c360f6a718e2f.jpg";